<template>
  <modal v-model="isActive">
    <div class="modal-content">
      <div class="message text-center">{{ message }}</div>
    </div>
    <div class="modal-button flex justify-between">
      <a @click="cancel" class="button-secondary block w-half">{{ $t('tour_cancel') }}</a>
      <a @click="ok" class="button-primary block w-half">OK</a>
    </div>
  </modal>
</template>

<script>
import Modal from "../atoms/Modal"

export default {
  components: {
    Modal
  },
  props: {
    message: {
      type: String,
      default: function () {
        return undefined
      }
    },
    success: {
      type: Function,
      default: function () {
        return {}
      }
    },
    failure: {
      type: Function,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      isActive: false
    }
  },
  created () {
    const el = document.createElement('div');
    document.getElementsByTagName('body')[0].appendChild(el);
    this.$mount(el);
    this.isActive = true;
  },
  methods: {
    ok: function () {
      this.success();
      this.destroy();
    },
    cancel: function () {
      this.failure();
      this.destroy();
    },
    destroy: function () {
      this.isActive = false;
      // 即座にdomを削除するとtransitionする前に消えてしまうので、200ms待つ
      setTimeout(() => {
        this.$el.parentNode.removeChild(this.$el);
        this.$destroy();
      }, 200);
    }
  }
}
</script>
